import { useRef } from "react";

export const useCallbackRef = (callback) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  
  const stableRef = useRef((...args) => callbackRef.current(...args));
  return stableRef.current;
};